import React, { useEffect, useState } from 'react'
import FilterPage, { generateInitialValue } from '../fragments/filter-page'
import {
    action_add_list_collection_list,
    action_fetch_list_collection_list,
    action_fetch_list_collection_sorters,
    action_fetch_list_collection_filter,
    __Default_List_Collection_Limit_For_DeskTop__
} from '../../../../../store/actions/pages/list-collections'
import withSource from '../../../../hocs/source-scoll'

import { filterItemsToString, getFilterItemsFromQuery, getUrl } from '../../../../pages/listing/utils'
import { useDispatch, useSelector, useStore } from 'react-redux'
import List from '../components/list'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import { FormattedMessage } from 'react-intl'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Empty from '../fragments/empty-page'
import BlockImage from '../../../components/image/block-image'
import { useSensors } from '../../../../hooks/sensor'
import { generateFilter } from '../../../../utils/sensor'



const getValidFilterItems = items => {
    const newItems = []

    items?.forEach(item => {
        if (['color', 'size', 'tags', 'category', 'category_ids'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0) {
            newItems.push(item)
        }
    })
    return newItems
}

const parseParams = search => {
    if (!search) return
    let newParams = {}
    Object.keys(search).forEach(key => {
        if (search[key] instanceof Array) {
            newParams[key] = search[key]?.filter((value, index, s) => s.indexOf(value) === index).join?.(',')
        } else {
            newParams[key] = search[key]
        }
    })

    if (search?.sort_by) {
        newParams['parentSkus'] = search.sort_by
    }

    if (search?.recommend_data_source) {
        newParams['recommendDataSource'] = search.recommend_data_source
    }

    return newParams
}

const CBlock = withSource(props => {
    useStyles(classes)
    const { item, currentCollectionId, innerRef, position, resourcePageTitle, theme } = props
    const location = useLocation()
    return <Link
        ref={innerRef}
        data-position={position}
        data-type='listing-tab'
        data-content={`collection@${item.id}`}
        data-title={resourcePageTitle}
        to={`${location.pathname}?collectionId=${item.id}`}
        style={{
            color: item.id === currentCollectionId ? theme?.activeFontColor : theme?.normalFontColor,
            backgroundColor: item.id === currentCollectionId ? theme?.activeFontBgColor : theme?.normalFontBgColor,
            width: `calc(${theme?.elementWidth} - 40px)`
        }}
        replace
        className={classes.CBlock}
        key={item?.id}>
        {
            item?.icon && <img className={classes.Icon} src={item?.icon}/>    
        } 
        <span dangerouslySetInnerHTML={{ __html: item?.styledTitle || item?.title }} />
    </Link>
})

const CollectionBlocks = props => {
    useStyles(classes)
    const { messageConfig, currentCollectionId } = props
    return <div className={classes.CBlocks}>
        {
            messageConfig?.collections?.map((item, index) => <CBlock theme={messageConfig?.theme} resourcePageTitle={messageConfig?.refId} item={item} key={item.id} position={index + 1} currentCollectionId={currentCollectionId} />)
        }
    </div>
}


const Banner = props => {
    useStyles(classes)
    const { banner } = props
    return <div className={classes.Banner}>
        <BlockImage href={banner.href} title={banner.refId} src={banner.src} width={banner.width} height={banner.height} />
    </div>
}


const ListCollection = props => {
    useStyles(classes)
    const dispatch = useDispatch()
    const store = useStore()
    const history = useHistory()
    const location = useLocation()
    const params = useParams()
    const pageCollection = useSelector((state) => state.pageListCollections)
    const messageConfig = pageCollection?.messageConfig
    const sorters = pageCollection?.sorters
    const query = useQuery()
    const [originQuery, setOriginQuery] = useState(query)

    const collectionId = query?.collectionId || messageConfig?.collections?.[0]?.id

    const baseUrl = `${location.pathname}?collectionId=${collectionId}`

    const [data, setData] = useState({
        collectionId,
        sorter: (sorters instanceof Array) ? sorters?.[query.sort || 0]?.value : query.sort,
        startPrice: Number(query?.lowerPrice) || undefined,
        endPrice: Number(query?.higherPrice) || undefined,
        filterItems: generateInitialValue(query, pageCollection?.filterVo?.filterItems)
    })

    const sort = sorters?.findIndex(s => s.value === data?.sorter) || 0


    const filterHandle = (filterItems, sort, price) => {
        const filter = {
            collectionId,
            sorter: (sorters instanceof Array) ? sorters?.[sort || 0]?.value : sort,
            startPrice: price?.minPrice || '',
            endPrice: price?.maxPrice || '',
            filterItems
        }
        setData(filter)
        dispatch(action_fetch_list_collection_list(filter, { limit: __Default_List_Collection_Limit_For_DeskTop__, recommendDataSource: originQuery?.recommend_data_source }, {}))
        const url = getUrl(baseUrl, filterItemsToString(filterItems, sort, price))
        history.replace(url)
    }

    const onScroll = () => {
        dispatch(action_add_list_collection_list(data, { ...query, parentSkus: query?.sort_by, skip: pageCollection?.skip, limit: __Default_List_Collection_Limit_For_DeskTop__, recommendDataSource: originQuery?.recommend_data_source }, {}))
    }

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            const values = await ListCollection.fetchData(store, params, query, {})
            setData({
                collectionId,
                sorter: (sorters instanceof Array) ? sorters?.[query.sort || 0]?.value : (query.sort || 0),
                startPrice: Number(query?.startPrice) || '',
                endPrice: Number(query?.endPrice) || '',
                filterItems: generateInitialValue(query, values[1]?.filterItems)
            })
        }

    }, [collectionId])

    const [sensors, setSensors] = useState(useSensors())

    const filterStr = generateFilter(pageCollection?.filterData, pageCollection?.sorters)

    return <FilterPage
        links={[
            {
                href: '#',
                title: <span>
                    <span>{messageConfig?.title}</span>
                    {
                        pageCollection?.total > 0 && <span className={classes.Total}>
                            (<FormattedMessage id="count_items" values={{ total: pageCollection?.total }} defaultMessage="{total} Items" />)
                        </span>
                    }
                </span>,
                keywords: [],
            }
        ]}

        extra={
            () => {
                return <>
                    {
                        messageConfig?.banner && <Banner sensors={{
                            position: 1,
                            content: messageConfig?.banner?.refId,
                            type: 'listing-top-banner'
                        }} banner={messageConfig?.banner} />
                    }
                    <CollectionBlocks messageConfig={messageConfig} currentCollectionId={collectionId} />
                </>
            }
        }
        showTags
        baseUrl={baseUrl}
        title={messageConfig?.title}
        filterVO={pageCollection?.filterVo}
        sorters={pageCollection?.sorters}

        value={data?.filterItems}
        sort={sort}
        minPrice={data?.startPrice}
        maxPrice={data?.endPrice}

        onFilter={filterHandle}>
        {
            pageCollection?.finished && (!pageCollection?.list || pageCollection?.list?.length < 1) ? <Empty /> : <List filter={filterStr} sensors={sensors} products={pageCollection?.list} request={onScroll} loading={pageCollection?.loading} finished={pageCollection?.finished} />
        }
    </FilterPage>
}


ListCollection.fetchData = async (store, params, search, headers) => {

    const initialFilterItems = getFilterItemsFromQuery(search)
    const sort = search.sort || 0
    const sorters = await store.dispatch(action_fetch_list_collection_sorters({}, headers))
    const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value : sort
    const collectionId = params.id || search?.collectionId

    const filter = {
        collectionId,
        sorter: sorter,
        startPrice: Number(search?.lowerPrice) || undefined,
        endPrice: Number(search?.higherPrice) || undefined,
        filterItems: getValidFilterItems(initialFilterItems),
    }

    const parsedParams = parseParams(search) || {}

    parsedParams.limit = __Default_List_Collection_Limit_For_DeskTop__




    const values = await Promise.all([
        store.dispatch(action_fetch_list_collection_list(filter, parsedParams, headers)),
        store.dispatch(action_fetch_list_collection_filter({ collectionId }, headers)),
    ])
    return [...values, sorters]
}

export default ListCollection